import { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { useQuery } from 'react-query';
import { get } from 'aws-amplify/api';

import {
    Menu,
    Drop,
    MenuItem,
    Arrow,
    DropButton,
    Search
} from '../styles/DropdownStyles'

const Dropdown = ({setGroupedAddresses, flipped, streetname, token, setAllLocations}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  const options = [
    { value: 'option1', label: '24th Street' },
    { value: 'option2', label: 'Castro Street' },
    { value: 'option3', label: 'Chestnut Street' },
    { value: 'option4', label: 'Clement Street' },
    { value: 'option5', label: 'Columbus Avenue' },
    { value: 'option6', label: 'Divisadero Street' },
    { value: 'option7', label: 'Fillmore Street' },
    { value: 'option8', label: 'Geary Boulevard' },
    { value: 'option9', label: 'Geary Street' },
    { value: 'option10', label: 'Grant Avenue' },
    { value: 'option11', label: 'Haight Street' },
    { value: 'option12', label: 'Hayes Street' },
    { value: 'option13', label: 'Irving Street' },
    { value: 'option14', label: 'Jefferson Street' },
    { value: 'option15', label: 'Lombard Street' },
    { value: 'option16', label: 'Market Street' },
    { value: 'option17', label: 'Mission Street' },
    { value: 'option18', label: 'Polk Street' },
    { value: 'option19', label: 'Post Street' },
    { value: 'option20', label: 'Presidio Avenue' },
    { value: 'option21', label: 'Sacramento Street' },
    { value: 'option22', label: 'Union Street' },
    { value: 'option23', label: 'Valencia Street' },
    { value: 'option24', label: 'Van Ness Avenue' },
    { value: 'option25', label: 'W Portal Avenue' },
  ];

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
    setSearchTerm(""); 
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  function abbreviateStreetName(streetName) {
          const abbreviations = {
              "Street": "St",
              "Avenue": "Ave",
              "Boulevard": "Blvd",
              "Place": "Pl",
              "Road": "Rd",
              "Drive": "Dr",
              "Court": "Ct",
              "Lane": "Ln",
              "Circle": "Cir",
              "Parkway": "Pkwy",
              "Square": "Sq"
          };
  
          if (!streetName || typeof streetName !== 'string') return "";
  
          const words = streetName.trim().split(" ");
          const lastWord = words[words.length - 1];
  
          if (abbreviations[lastWord]) {
              words[words.length - 1] = abbreviations[lastWord];
          }
  
          return words.join(" ");
      }
  
      /**  HANDLES GETTING ALL LOCATION DATA  **/
        const addresses = useQuery(['data', streetname], () => {
      
            async function getData(){
                // Create a get request to get all location data
                try{
                    const street_name = abbreviateStreetName(streetname);
                    const data = get({
                        apiName: 'LocationAPI',
                        path: `/location/all-data?streetname=${encodeURIComponent(street_name)}`,
                        options: {
                            headers: {
                                Authorization: `Bearer ${token}`
                            }
                        }
                    })
      
                    const { body } = await data.response;
                    const res = await body.json();
                    console.log('Getting all location data GET call succeeded for Map');
      
                    var locations = [];
                    // Get all the addresses into an array of JSON objects
                    for(var i = 0; i < res.addresses.length; i++) {
                        locations.push({address: res.addresses[i].address,
                                        name: res.addresses[i].businessName,
                                        id: res.addresses[i]._id});
                    }
                    setAllLocations(locations);
      
                    return res;
                } catch(e){
                    console.log('Getting all location data GET call failed for Map: ', e);
                }
            }
      
            if(token){
                return getData();
            }
        })

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // This filters options based on the search word
  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
      const addressList = Array.isArray(addresses?.data?.addresses) ? addresses?.data?.addresses : [];
      const grouped = {};
      const allNumbers = [];
  
      addressList.forEach(addressObj => {
          const buildingNumber = parseInt(addressObj.address.split(" ")[0], 10);
          allNumbers.push(buildingNumber);
          const hundredGroup = Math.floor(buildingNumber / 100) * 100; // Get the hundreds group
          const isEven = buildingNumber % 2 === 0;
          const groupKey = isEven ? "evens" : "odds";
  
          if (!grouped[hundredGroup]) {
              grouped[hundredGroup] = { odds: [], evens: [] };
          }
  
          grouped[hundredGroup][groupKey].push(addressObj);
      });
  
      if(flipped){
        // Sort descending addresses within each group
        Object.keys(grouped).forEach(hundred => {
          grouped[hundred].odds.sort((a, b) => {
              const numA = parseInt(a.address.split(" ")[0], 10);
              const numB = parseInt(b.address.split(" ")[0], 10);
              return numB - numA;
          });
  
          grouped[hundred].evens.sort((a, b) => {
              const numA = parseInt(a.address.split(" ")[0], 10);
              const numB = parseInt(b.address.split(" ")[0], 10);
              return numB - numA;
          });
      });
      } else {
        // Sort ascending addresses within each group
        Object.keys(grouped).forEach(hundred => {
          grouped[hundred].odds.sort((a, b) => {
              const numA = parseInt(a.address.split(" ")[0], 10);
              const numB = parseInt(b.address.split(" ")[0], 10);
              return numA - numB; 
          });

          grouped[hundred].evens.sort((a, b) => {
              const numA = parseInt(a.address.split(" ")[0], 10);
              const numB = parseInt(b.address.split(" ")[0], 10);
              return numA - numB;
          });
        });
      }
      

      if (allNumbers.length > 0) {
        const minGroup = Math.floor(Math.min(...allNumbers) / 100) * 100;
        const maxGroup = Math.floor(Math.max(...allNumbers) / 100) * 100;

        for (let group = minGroup; group <= maxGroup; group += 100) {
            if (!grouped[group]) {
                grouped[group] = { odds: [], evens: [] };
            }
        }
      }
  
      setGroupedAddresses(grouped);
  }, [addresses?.data?.addresses]);

  return (
    <Drop ref={dropdownRef}>
      <DropButton className="dropdown-button" onClick={toggleDropdown}>
        {selectedOption ? selectedOption.label : 'Select A Street'}
        <Arrow />
      </DropButton>
      {isOpen && (
        <Menu>
          <Search
            type="text"
            placeholder="Search Street Names..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <Link key={option.value} to={`/auth/map/${encodeURIComponent(option.label)}`} className="dropdown-link" style={{color:"black", textDecoration:"none"}}>
                <MenuItem
                  className="dropdown-item"
                  onClick={() => handleOptionClick(option)}
                >
                  {option.label}
                </MenuItem>
                </Link>
            ))
          ) : (
            <p style={{ padding: "5px", color: "#888" }}>No results found</p>
          )}
          
        </Menu>
      )}
    </Drop>
  );
};

export default Dropdown;